import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { unwrapErrorResponse, unwrapResponse } from '@/utils/unwrapResponse'
import { APIErrorResponse, Equipment } from '@/types'

export const useEquipments = (): UseQueryResult<
  Equipment[],
  APIErrorResponse
> => {
  const client = useApiClient()

  return useQuery(['users', 'equipments'], () =>
    client
      .get(`/users/equipments/`)
      .then(unwrapResponse)
      .catch(unwrapErrorResponse)
  )
}
